export enum NewrelicError {
  PLAYBACK_ERROR = 'PLAYBACK_ERROR',
  UMS_ERROR = 'UMS_ERROR',
  AD_ERROR = 'AD_ERROR',
  APP_ERROR = 'APP_ERROR',
  DOWNLOAD_ERROR = 'DOWNLOAD_ERROR',
}
